module.exports = __webpack_public_path__ + "img/exchange-c.8922a292.svg";